import Link from "~/bridge/ui/Link";
import { useAppContext } from "../../app-context/provider";
import { fetchNavigationByFolders } from "~/use-cases/crystallize/read/fetchNavigation";

export const TopicNavigation: React.FC<{
  navigation: Awaited<
    ReturnType<typeof fetchNavigationByFolders>
  >["catalogue"]["children"];
}> = ({ navigation }) => {
  const { path } = useAppContext();
  return (
    <>
      {navigation.map((topic) => {
        const numberOfTopics = topic.children?.length ?? 0;
        const calculateColumns = numberOfTopics / 12;
        const numberOfCols =
          calculateColumns <= 1 ? 1 : Math.round(calculateColumns);
        return (
          <span className="nav-anchor shrink-0" key={topic.path}>
            <span className="text-lg xl:text-[15px] 2xl:text-[16px] block whitespace-nowrap">
              <Link to={path(topic.path ?? "")}>{topic.name}</Link>
            </span>
            {numberOfTopics > 0 && (
              <>
                <span className="hidden xl:flex text-[11px] caret">▼</span>
                <ul
                  className="nav-dropdown"
                  style={{
                    gridTemplateColumns: `repeat(${numberOfCols}, 1fr)`,
                  }}
                >
                  {topic.children?.map((child: any) => (
                    <Link to={path(child.path)} key={child.path}>
                      <li className="nav-dropdown__item text h-full text-md w-full">
                        {child.name}
                      </li>
                    </Link>
                  ))}
                </ul>
              </>
            )}
          </span>
        );
      })}
      <span className="nav-anchor shrink-0" key={"blog"}>
        <span className="text-lg xl:text-[15px] 2xl:text-[16px] block whitespace-nowrap">
          <Link to={path("/tips-og-rad")}>Tips og råd</Link>
        </span>
      </span>
    </>
  );
};
